import React, { useState } from "react";
import { Modal, Button, Form, Alert, Row, Col, Spinner, Tab, Tabs } from "react-bootstrap";
import { FaSearch, FaDownload } from "react-icons/fa";
import * as XLSX from "xlsx";

const ModalGenerar = ({
    show,
    onHide,
    generando,
    parametros,
    setParametros,
    onAnalizar
}) => {
    const [file, setFile] = useState(null);

    React.useEffect(() => {
        if (!show) {
            setFile(null);
        }
    }, [show]);

    const handleFechaCorteChange = (e) => {
        setParametros({ ...parametros, fechaCorte: e.target.value });
    };

    const handleMetodoChange = (k) => {
        setParametros({ ...parametros, metodo: k });
    };

    const handleAnalizar = () => {
        onAnalizar(file);
    };

    const downloadTemplate = () => {
        const templateData = [
            {
                DNI: "12345678",
                Fecha: "2026-01-20",
                Tipo: "falta",
                "Días Afectados": 1,
                "Horas Afectadas": 8,
                "Minutos Tardanza": 0,
                "Con Goce": "No",
                "Justificado": "No",
                "Motivo": "Ejemplo Falta",
                "Observaciones": "",
                "Horas 25%": 0,
                "Horas 35%": 0,
                "Horas 100%": 0
            }
        ];
        const ws = XLSX.utils.json_to_sheet(templateData);

        const helpData = [
            { "Campo": "Tipo (Valores Válidos)", "Descripción": "falta, vacaciones, descanso_medico, licencia, tardanza, permiso, he_25, he_35, he_100" },
            { "Campo": "Fecha", "Descripción": "YYYY-MM-DD" }
        ];
        const wsHelp = XLSX.utils.json_to_sheet(helpData);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Plantilla");
        XLSX.utils.book_append_sheet(wb, wsHelp, "Ayuda");
        XLSX.writeFile(wb, "Plantilla_Ocurrencias.xlsx");
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Configuración de Generación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Período a procesar *</Form.Label>
                            <Form.Select
                                value={parametros.periodo}
                                onChange={(e) => setParametros({ ...parametros, periodo: e.target.value })}
                            >
                                <option value="">Seleccionar período</option>
                                {(() => {
                                    const currentYear = new Date().getFullYear();
                                    const periods = [];
                                    for (let year = currentYear; year >= currentYear - 1; year--) {
                                        for (let month = 12; month >= 1; month--) {
                                            const monthStr = month.toString().padStart(2, "0");
                                            const periodValue = `${year}-${monthStr}`;
                                            const monthNames = [
                                                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                                                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                                            ];
                                            periods.push(
                                                <option key={periodValue} value={periodValue}>
                                                    {monthNames[month - 1]} {year}
                                                </option>
                                            );
                                        }
                                    }
                                    return periods;
                                })()}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Opciones Generales</Form.Label>
                            <Form.Check
                                type="checkbox"
                                label="Sobreescribir datos anteriores"
                                checked={parametros.sobreescribir}
                                onChange={(e) => setParametros({ ...parametros, sobreescribir: e.target.checked })}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Tabs
                    activeKey={parametros.metodo}
                    onSelect={handleMetodoChange}
                    className="mb-3"
                >
                    <Tab eventKey="automatico" title="🤖 Automático (Asistencia/Ausencias)">
                        <Alert variant="info" className="mt-3">
                            <small>
                                Analiza registros de: <br />
                                1. <strong>Regímenes Laborales</strong> (Días y Horarios). <br />
                                2. <strong>Ausencias Aprobadas</strong> (Vacaciones, Licencias). <br />
                                3. <strong>Marcaciones de Asistencia</strong> (Faltas y Tardanzas).
                            </small>
                        </Alert>
                        <Form.Group className="mb-3">
                            <Form.Label>Fecha de corte (opcional)</Form.Label>
                            <Form.Control
                                type="date"
                                value={parametros.fechaCorte}
                                onChange={handleFechaCorteChange}
                                min={parametros.periodo ? `${parametros.periodo}-01` : ""}
                            />
                        </Form.Group>
                    </Tab>

                    <Tab eventKey="excel" title="📄 Importar Excel">
                        <Alert variant="light" className="mt-3 border">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>Carga Manual:</strong> Usa esto si no tienes control de asistencia en el sistema.
                                </div>
                                <Button variant="outline-success" size="sm" onClick={downloadTemplate}>
                                    <FaDownload className="me-1" /> Plantilla
                                </Button>
                            </div>
                        </Alert>
                        <Form.Group className="mb-3">
                            <Form.Label>Archivo Excel (.xlsx)</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={(e) => setFile(e.target.files[0])}
                            />
                        </Form.Group>
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={generando}>Cerrar</Button>
                <Button
                    variant="primary"
                    onClick={handleAnalizar}
                    disabled={!parametros.periodo || generando || (parametros.metodo === 'excel' && !file)}
                >
                    {generando ? <Spinner size="sm" /> : <FaSearch className="me-2" />}
                    {parametros.metodo === 'excel' ? 'Analizar Excel' : 'Analizar Sistema'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalGenerar;
